import React, { useState, useEffect } from "react";
import "./counter.css"
function Counter({ start = 50, end = 100, duration = 2000 }) {
  const [count, setCount] = useState(start);

  useEffect(() => {
    let startTime = null;
    const step = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      const current = Math.floor(progress * (end - start) + start);
      setCount(current);
      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };
    requestAnimationFrame(step);
  }, [start, end, duration]);

return (
  <span className="counter">
    {count}
    <span className="plus">+</span>
  </span>
);}

export default Counter;
